export const Roles = {
  "General Manager": "gm",
  "Marketing Manager": "marketing",
  "Learning and Development manager": "learning_development",
  FRONTLINE: "super-admin",
  ADMIN: "super-admin",
  "GROUP ADMIN": "group-admin"
}
